import React from "react";
import {useTranslation} from "react-i18next";

import MDTypography from "../../../materialDashboard/components/MDTypography";
import {DatePicker} from "@mui/x-date-pickers";

import Stack from "@mui/material/Stack";
import ActivationButtons from "./ActivationButtons";


const ActivityPeriodSection = ({formik, station}) => {
    const {t} = useTranslation(['stations']);

    return <Stack spacing={1}>
        <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
            {t('stationForm.activityPeriod')}
        </MDTypography>
        <DatePicker value={formik.values.activatedAt}
                    label={t('stationForm.activatedAt')}
                    onChange={(date) => formik.setFieldValue("activatedAt", date)}
                    sx={{width: "100%"}}
                    slotProps={{
                        textField: {
                            variant: 'standard',
                            error: formik.touched.activatedAt && Boolean(formik.errors.activatedAt),
                            helperText: formik.touched.activatedAt && formik.errors.activatedAt,
                        }}}
        />
        <DatePicker value={formik.values.deactivatedAt}
                    label={t('stationForm.deactivatedAt')}
                    onChange={(date) => formik.setFieldValue("deactivatedAt", date)}
                    sx={{width: "100%"}}
                    slotProps={{
                        textField: {
                            variant: 'standard',
                            error: formik.touched.deactivatedAt && Boolean(formik.errors.deactivatedAt),
                            helperText: formik.touched.deactivatedAt && formik.errors.deactivatedAt,
                        }}}
        />
        <ActivationButtons formik={formik} station={station} />
    </Stack>
}

export default ActivityPeriodSection;